import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
export function AppRouter() {
  return <BrowserRouter data-id="element-34">
      <App data-id="element-35" />
    </BrowserRouter>;
}